/*----- Core -----*/
import styled from 'styled-components'

/*----- Commons -----*/
import Color      from '../../commons/Color'
import Device from '../../commons/Device'
import Montserrat from '../../commons/mixins/fonts/Montserrat'

/*----- Export -----*/
export default styled.main`

/***  Portrait ***/
	.portrait__text-container {
		max-width: 500px;
		height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
		padding-top: 64px;
	}
	.portrait__title {
		${ Montserrat(40, 800, Color.main) };
		line-height: 40px;
		text-transform: uppercase;
	}
	.portrait__subtitle {
		${ Montserrat(18, 400, Color.grey) };
		line-height: 20px;
	}
	.handler-button {
		margin: 32px 0;
	}
	.portrait__image-container {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding-top: 32px;
		img {
			max-width: 800px;
			width: 100%;
			border-radius: 10px;
		}
	}

/***  Form & Avatar ***/
	.contact-form-container {
		max-width: 100%;
		width: 100%;
		background: white;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 400px;
		form {
			width: 100%;
			.ant-input, .ant-input-number {
				border: none;
				border-bottom: 3px solid ${Color.main};
			}
			padding: 16px;
			box-shadow: 0 16px 32px 16px rgb(48 137 252 / 0.1);
			border-radius: 8px;
			z-index: 1;
		}
		.handler-button {
			max-width: 100%;
			width: 100%;
		}
	}
	.handler-button {
		height: 50px;
		font-size: 18px;
	}
	.producer-avatar {
		max-width: 400px;
		width: 100%;
		margin: 32px 0;
		.producer-avatar__img {
			display: grid;
			grid-column-gap: 8px;
			grid-template-columns: 80px 180px;
			border-radius: 8px;
			align-items: center;
			img {
				border-radius: 50%;
				max-width: 100px;
				width: 100%;
			}
		}
		.producer-avatar__mat {
			${ Montserrat(16, 600, Color.grey) };
			padding-left: 16px;
		}
	}

/***  Insurance details ***/
	.insurance-details__background {
		background-color: #f7f7f7;
	}
	.insurance-details {
		margin-top: 64px;
		.insurance-details__list {
			display: grid;
			grid-column-gap: 8px;
			grid-template-columns: repeat(1, 100%);
			padding-right: 16px;
			border-radius: 8px;
			width: 100%;
			padding: 0;
		}
		.insurance-details__item {
			list-style: none;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			margin: 16px 0;
			img {
				width: 60px;
			}
			p {
				${ Montserrat(16, 500, Color.grey) };
				margin: 0;
				max-width: 350px;
				margin-left: 16px;
			}
		}
	}

/***  Benefit list ***/
	.benefit__list {
		padding: 0;
		width: 100%;
		display: grid;
		grid-column-gap: 8px;
		grid-template-columns: repeat(2, 50%);
		list-style: none;
	}
	.benefit__item {
		padding: 8px;
	}

/***  Media queries ***/
	@media ${Device.sm} {
		.insurance-details {
			margin-top: 200px;
			.insurance-details__list {
				grid-template-columns: repeat(2, 50%)	
			}
		}
	}
	@media ${Device.md} {
		padding-top: 64px;
		.avatar-and-form {
			height: 300px;
		}
	}
	@media ${Device.lg} {
		.portrait__title {
			font-size: 60px;
			line-height: 64px;
		}
		.portrait__subtitle {
			font-size: 26px;
				line-height: 32px;
		}
		.portrait__image-container {
			padding: 32px;
		}
		.contact-form-container {
			max-width: 450px;
		}
		.hero-paragraph__title { 
			font-size: 40px;
			line-height: 40px;
		}
		.producer-avatar > .custom-paragraph { 
			font-size: 20px;
		}
		.benefit__list {
			grid-template-columns: repeat(3, 33.3%);
		}
		.hero-paragraph__text-container {
			max-width: 700px;
		}
	}

`